import React, { useState } from 'react';

export default function Login({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    await new Promise(resolve => setTimeout(resolve, 300));
    
    const ok = await onLogin(password);
    if (!ok) {
      setError('❌ Wrong password. Try again.');
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <h1>🌱 Ecoholic</h1>
          <p>Admin Dashboard — Attendance System</p>
        </div>
        <form onSubmit={handleSubmit}>
          <label>Admin Password</label>
          <input
            type="password"
            id="admin-password"
            placeholder="Enter password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            autoFocus
          />
          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? 'Verifying...' : 'Login →'}
          </button>
          {error && <p className="login-error">{error}</p>}
        </form>
      </div>
    </div>
  );
}
